<template>
  <div @click="CLOSE_TABLEBOX_DATAS" v-show="tableBoxDatas.show" class="Bigbox">
    <div @click.stop class="tableBox">
      <table class="pure-table-bordered">
        <thead>
          <tr>
            <th :style="{
              width: `${tableBoxDatas.widthObj[key] * 10}%`
            }" v-for="(item, key, index) in tableBoxDatas.thDatas" :key="index">
              {{ item }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="thItem in tableBoxDatas.tdDatas" :key="thItem.id">
            <td v-for="(item, key, index) in tableBoxDatas.thDatas" :key="'th' + index" :style="{
              width: `${tableBoxDatas.widthObj[key] * 10}%`
            }">
              {{ thItem[key] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'TableBox',
  computed: {
    ...mapState(['tableBoxDatas'])
  },
  methods: {
    ...mapActions(['CLOSE_TABLEBOX_DATAS'])
  }
}
</script>
<style lang="less" scoped>
.Bigbox {
  width: 100%;
  height: 100%;
  position: fixed;
  top:0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: rgba(255, 255, 255, 0.3);
  z-index: 1000;
}
.tableBox {
  border-radius: 10px;
  margin-top: 10%;
  width: 80%;
  max-height: 80%;
  background: #052666;
  border: 2px solid #006CC8;
  cursor: pointer;
}
tbody::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 5px;
  display: none;
}
tbody::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: #272525;
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent 100%
  );
}
tbody::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}
.pure-table-bordered {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout:fixed;
  text-align: center;
  tbody{
    overflow: auto;
    width: 100%;
    max-height: 6rem;
    display: block;
    scrollbar-width: none;
    // &:hover{
    //   width: calc(100% + 3px);
    //   &::-webkit-scrollbar{
    //     display: block;
    //   }
    // }
  }
  tr{
    width: 100%;
    display: table;
    table-layout: fixed;
    box-sizing: border-box;
  }
  th,
  td {
    border: 1px solid #517FB5;
    &:first-child {
      border-left: none;
    }
    &:last-child {
      border-right: none;
    }
  }
  th {
    font-size: 0.15rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #02d9fd;
    padding: 0.13rem 0;
    box-sizing: border-box;
  }
  td {
    font-size: 0.14rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    padding: 0.1rem 0.2rem;
    box-sizing: border-box;
    word-wrap:break-word;
  }
  tr:first-child th {
    border-top: none;
  }
  tr:last-child td {
    border-bottom: none;
  }
}
</style>